import React from 'react';
import { TextV2, ButtonV2, Flex } from '@withjoy/joykit';
import { ResponsiveDialog } from '@apps/card/components/ResponsiveDialog';
import RecipientsPicker from './components/RecipientsPicker/RecipientsPicker';
import { useRootController } from './Root.controller';

interface RootProps {
  eventId: string;
  eventHandle: string;
  firebaseEventId: string;
}

const Root: React.FC<RootProps> = ({ eventId, eventHandle, firebaseEventId }) => {
  const {
    tAdmin,
    isLoading,
    isDeleteContactsMutationLoading,
    recipients,
    setRecipients,
    createRecipient,
    updateRecipient,
    deleteRecipients,
    isOpen,
    onOpen,
    onClose,
    selectedRecipientsQuantity
  } = useRootController(eventId, eventHandle, firebaseEventId);

  if (isLoading) {
    return null;
  }

  return (
    <>
      <RecipientsPicker recipients={recipients} setRecipients={setRecipients} createRecipient={createRecipient} updateRecipient={updateRecipient} deleteRecipients={onOpen} />
      <ResponsiveDialog
        isOpen={isOpen}
        onClose={onClose}
        header={() => <TextV2 typographyVariant="hed3">{tAdmin.deleteGuest()}</TextV2>}
        content={() => (
          <Flex flexDirection="column" gap={8}>
            <TextV2 fontSize="15px" lineHeight="21px">
              {`${tAdmin.confirmDelete()} ${selectedRecipientsQuantity} ${
                selectedRecipientsQuantity === 1 ? tAdmin.guest().toLocaleLowerCase() : tAdmin.guests().toLocaleLowerCase()
              } ${tAdmin.confirmDeleteCont()}.`}
            </TextV2>
            <Flex gap={4} flexDirection={{ _: 'column-reverse', sm2: 'row' }} width="100%" justifyContent="space-between">
              <ButtonV2 intent="neutral" shape="rounded" variant="outline" onClick={onClose} disabled={isDeleteContactsMutationLoading}>
                {tAdmin.cancelCta()}
              </ButtonV2>
              <ButtonV2
                intent="neutral"
                shape="rounded"
                onClick={() => {
                  deleteRecipients(selectedRecipientsQuantity);
                }}
                disabled={isDeleteContactsMutationLoading}
              >
                {tAdmin.deleteCta()}
              </ButtonV2>
            </Flex>
          </Flex>
        )}
      />
    </>
  );
};

export default Root;
